<template>
  <div class="wrapper">
    <div class="page-header page-header-large">
      <parallax
        class="page-header-image"
        style="background-image: url('img/presentation/product_main.png'); background-color: rgba(0, 0, 0, 0);"
      ></parallax>

      <!-- platform-connected-cars.png -->

      <div class="content-center">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto">
            <h2 class="title">Turn your car into a whole new ride with</h2>
            <h1 class="title" style="padding-top: 0px; color:#C0FFEE" font->AiCAR</h1>
            <!-- 
            <h8 class="description">
                Our cloud-based platform enables infrastructure services and connectivity offering seamless, deeply integrated services, based upon our extensive 20 years of expertise in automotive.
            </h8>
            -->
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <!-- <img class="img" alt="Raised Image" src="img/prada/aicar_prada-600x367.png" /> -->
          </div>
        </div>
      </div>

      <!-- 
            <div class="about-office">
                <div class="container">
                    <div class="row text-center">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h2 class="title">Our office is our second home</h2>
                            <h4 class="description">Here are some pictures from our office. You can see the place
                                looks like a palace and is fully equiped with everything you need to get the job
                                done.</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg27.jpg">
                        </div>
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg24.jpg">
                        </div>
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg28.jpg">
                        </div>
                        <div class="col-md-6">
                            <img class="rounded img-raised" alt="Raised Image" src="img/project6.jpg">
                        </div>
                        <div class="col-md-6">
                            <img class="rounded img-raised" alt="Raised Image" src="img/project14.jpg">
                        </div>
                    </div>
                </div>
            </div>
      -->
    </div>

   <div class="about-office" style="padding-bottom: 0px;">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-12 ml-auto mr-auto">
            <h2 class="title">Car Sharing App</h2>
            <h8
              class="description"
            >AiCAR is a connected car device and app that provides users with a rich ecosystem of services, including emergency crash assistance, vehicle diagnostics, roadside assistance management and many more. It can also turn your vehicle into a powerful Wi-Fi hotspot.</h8>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <img class="img" alt src="img/prada/prada-product-1024x800.png" />
          </div>
        </div>
      </div>
    </div>
<!-- 
    <div class="main">
      <div class="container">
        <div class="section">
          <h2 class="title text-center">Connected Car App</h2>
          <p>AiCAR will help transform your car thanks to its wide range of features, all controlled through a single app with its own built-in payment platform.</p>
          <br /> --> 
          
          <!-- type="card"  :interval="5000"  -->
          <!-- <el-carousel autoplay="true" height="750px" arrow="always" indicator-position="outside">
            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/wifi-zoom-400x600.jpg" />
                  <h4 class="card-title">Wi-Fi Hotspot</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Connect up to 8 devices and stream, browse, share and more from the open road.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/virtual-mechanic-400x600.jpg" />
                  <h4 class="card-title">Virtual Mechanic</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Keep your car in great shape. The virtual mechanic monitors your vehicle’s health and lets you know what to do if there’s a problem.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/watchit-400x600.jpg" />
                  <h4 class="card-title">WatchIt</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Park with peace of mind knowing WatchIt is keeping a close eye on your car. You’ll receive an alert if your car is bumped, moved, or towed, and the location tracker can even help authorities find it if it’s stolen.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img
                    slot="image"
                    class="img"
                    src="img/prada/emergency-crash-assistance-400x600.jpg"
                  />
                  <h4 class="card-title">Emergency Crash Assistance</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Get help when you need it most. If you’re involved in a crash, the Emergency Crash Assistance feature will automatically send an alert to your phone. If you’re unable to respond, your emergency contacts will be notified.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img
                    slot="image"
                    class="img"
                    src="img/prada/roadside-assistance-manager-400x600.jpg"
                  />
                  <h4 class="card-title">Roadside Assistance Manager</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Get roadside assistance at the drop of a pin. Receive a quote, pay for it using the app, and help will be on its way.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/trips-400x600.jpg" />
                  <h4 class="card-title">Trips</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Keep a record of the details of your trips, including time and mileage, and get information on your driving habits such as speed insights, hard braking, rapid acceleration, and more. Trips can be organized and saved by type, too.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/geofences-400x600.jpg" />
                  <h4 class="card-title">Geofences</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Draw boundaries on a map, view vehicle locations, and get a notification when any of your family cars enter or exit the geofenced area.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/driving-score-400x600.jpg" />
                  <h4 class="card-title">Driving Score</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Receive a driving score based on your driving habits and get helpful tips on how to become a safer and smarter driver.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/family-mode-400x600.jpg" />
                  <h4 class="card-title">Family Share</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >Share trip and location information with family members to keep everyone in the loop.</p>
                </card>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="col-md-12" style="text-align: center;">
                <card type="blog" plain>
                  <img slot="image" class="img" src="img/prada/parking-400x600.jpg" />
                  <h4 class="card-title">Parking Reservations</h4>
                  <p
                    class="card-description"
                    style="text-align: justify;"
                  >You don’t need to keep circling for a parking spot. Save time by searching, booking, and paying for parking using the app.</p>
                </card>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div> -->

    <!-- <div
      class="section section-cards"
      style="background-image: url('img/prada/paycar-bg-test.jpg');"
    > -->
      <!-- <div class="container">
        <div class="row"> -->
          <!-- <div class="col-lg-5 col-md-7 ml-auto mr-auto"> -->
            <!-- 
            <div class="col-md-12" style="display: inline-block; padding: 15px;">
              <img class="img" alt src="img/prada/badge-paycar-600x322.png" />
            </div>
            -->

            <!-- <h2 class="title" style="color: #ffffff;">A single click for all in-car mobility</h2> -->

            <!-- <h6 class="category">Technology to combat pollution</h6> -->

            <!-- 
            <h5 class="description" style="color: #ffffff;">
              AiCAR can fully incorporate brand design guidelines and strategy into the platform.
              All functions and features are fully customisable: our ecosystem of services can also be integrated into existing applications on a selective basis – allowing you to create the best solution.
              Our Air.Car and Pay.Car platforms can also be integrated with your current systems, allowing you to create the best connected car experience possible.
            </h5>
            -->
          <!-- </div> -->

          <!-- <div class="col-md-5"> -->
          <!-- <div class="col-lg-6 col-md-12"> -->
            <!-- <div class="image-container"> -->
              <!-- class="img img-raised rounded img-comments rellax" -->
              <!-- <img
                class="img"
                data-rellax-speed="1"
                src="img/prada/paycar-spark-screens-600x600.png"
                alt="content 1"
              /> -->
            <!-- </div> -->
          <!-- </div> -->
        <!-- </div> -->
      <!-- </div> -->
    <!-- </div> -->

    <div class="about-office" style="padding-bottom: 10px;">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-12 ml-auto mr-auto">
            <h2 class="title">Car Sharing Admin Web</h2>
            <h8
              class="description"
            >Not on your phone? Make changes to your account from the comfort of your computer. Change your information or control your vehicle dashboard, your previous trips and your geofences through the AiCAR Prada Web Portal.</h8>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <img class="img" alt src="img/prada/admin_web.png" />
          </div>
        </div>

        <div class="row text-center">
          <div class="col-md-12 ml-auto mr-auto">
            <!-- <h3 class="title" style="color: #0076ff;">Exclusively from AT&T</h3> -->

            <!--             
            <h8
              class="description"
            >Not on your phone? Make changes to your account from the comfort of your computer. Change your information or control your vehicle dashboard, your previous trips and your geofences through the HARMAN Spark Web Portal.</h8>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox
} from "@/components";

import { Select, Option, Carousel, CarouselItem } from "element-ui";

export default {
  name: "about-us",
  bodyClass: "about-us",
  components: {
    Card,
    InfoSection,
    Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },

  data() {
    return {
      form: {
        firstName: "",
        email: "",
        speciality: ""
      },

      carouselIndex: 0
    };
  },

  methods: {
    carouselChange(index) {
      this.carouselIndex = index;
    },
    onNext() {
      this.$refs.carousel.next();
      console.log("next");
    }
  }
};
</script>

<style>
</style>
